/**
 * JoSmartTech Academy — i18n centralisé
 *
 * Pour activer le Lingala plus tard :
 *   1. Ajouter `ln: { ... }` à T avec les traductions
 *   2. Ajouter le bouton dans le LangSwitcher (FR | EN | LN)
 *   Le hook `useT(lang)` retombe automatiquement en FR si la clé n'existe pas.
 */

export const T = {
  fr: {
    /* === NAVBAR & GLOBAL === */
    nav_home: 'Accueil',
    nav_about: 'À propos',
    nav_formations: 'Nos formations',
    nav_login: 'Connexion',
    nav_dashboard: 'Tableau de bord',
    nav_modules: 'Modules',
    nav_admin: 'Admin',
    nav_logout: 'Déconnexion',
    back: 'Retour',

    /* === HOME : HERO === */
    hero_badge: 'Apprenez à votre rythme, gagnez en confiance',
    hero_subtitle: "Apprenez l'anglais et nos formations professionnelles avec une méthode interactive : écouter, répéter, pratiquer, valider.",
    hero_cta_start: 'Commencer gratuitement',
    hero_cta_try: 'Essayer maintenant',
    hero_cta_discover: 'Découvrir les formations',

    /* === HOME : FORMATIONS === */
    formations_title: 'Nos formations',
    formation_english_tag: 'Mode interactif · 6 niveaux · 🇬🇧',
    formation_english_title: 'Apprendre l\'anglais',
    formation_english_desc: "Du Débutant au Fluent — méthode 5 étapes (Cours, Lecture, Exercices, Mini-chat, Audio Repeat) pour apprendre l'anglais pas à pas.",
    formation_english_cta: 'Découvrir',
    formation_pro_tag: 'Mode académique',
    formation_pro_title: 'Formations Pro',
    formation_pro_desc: "Formation accélérée : créer sites web & applications avec l'IA — présentiel ou en ligne.",
    formation_pro_cta: 'Découvrir',
    formations_more_banner: "💡 D'autres formations arrivent prochainement : Marketing digital, Intelligence artificielle, Business, Productivité…",
    formations_catalog_badge: 'Catalogue complet',
    formations_intro: "Choisis ton domaine d'apprentissage. Chaque formation suit notre méthode interactive : écouter, répéter, pratiquer, valider.",

    /* === HOME : WHY CHOOSE === */
    why_title: 'Pourquoi nous choisir ?',
    why_sub: 'Une méthode pensée pour la confiance et la pratique réelle',
    why_method: 'Méthode interactive',
    why_method_desc: '4 étapes par leçon : Lire, Pratiquer, Discuter, Écouter & Répéter.',
    why_audio: 'Audio illimité',
    why_audio_desc: 'Écoutez et répétez chaque phrase à votre rythme.',
    why_gami: 'Gamification',
    why_gami_desc: 'Points XP, streaks, vies et badges pour rester motivé.',
    why_certs: 'Certificats',
    why_certs_desc: 'Validez officiellement vos progrès en fin de formation.',

    /* === HOME : FOUNDER === */
    founder_eyebrow: 'Le mot du fondateur',
    founder_role: 'Fondateur · CEO',
    founder_quote: '« Le savoir n\'a',
    founder_quote_em: 'pas de frontières',
    founder_p1_a: "À tous les ",
    founder_p1_youth: 'jeunes',
    founder_p1_b: ", à tous les ",
    founder_p1_entrepreneurs: 'entrepreneurs',
    founder_p1_c: ", à tous celles et ceux qui osent rêver plus grand : ce projet est pour vous.",
    founder_p2_a: "JoSmartTech est né d'une conviction simple — ",
    founder_p2_strong: "la technologie et la connaissance doivent appartenir à tout le monde",
    founder_p2_b: ", partout dans le monde. Quel que soit votre continent, votre langue, votre point de départ : vous méritez les mêmes outils, la même qualité d'apprentissage, les mêmes opportunités.",
    founder_p3_a: "Aujourd'hui, internet a aboli les distances. Une idée née dans une petite chambre peut changer le monde. Un talent peut émerger de n'importe où. Notre rôle ici est simple : vous donner ",
    founder_p3_strong: "les compétences, la confiance et la régularité",
    founder_p3_b: " pour transformer cette possibilité en réalité.",
    founder_p4_a: "N'attendez pas le moment parfait. Apprenez aujourd'hui. Pratiquez demain. Bâtissez après-demain. Et souvenez-vous : ",
    founder_p4_strong: "chaque grand parcours commence par une seule leçon",
    founder_signature_role: 'Fondateur de JoSmartTech',

    /* === HOME : FEATURES === */
    features_title: 'Fonctionnalités essentielles',
    features_sub: "Tout ce que vous attendez d'une plateforme moderne, et plus encore",
    feat_method_title: 'Méthode interactive',
    feat_method_desc: '5 étapes par leçon : Cours, Lire, Pratiquer, Discuter, Écouter & Répéter.',
    feat_audio_title: 'Audio illimité',
    feat_audio_desc: 'Écoutez et répétez chaque phrase à votre rythme — autant de fois que nécessaire.',
    feat_gami_title: 'Gamification',
    feat_gami_desc: 'Points XP, streaks, vies et badges pour rester motivé chaque jour.',
    feat_certs_title: 'Certificats officiels',
    feat_certs_desc: 'Recevez un certificat JoSmartTech à la fin de chaque formation complète.',
    feat_ai_title: 'Petit test rapide',
    feat_ai_desc: '10 questions pour t\'échauffer, puis tu démarres sereinement au Niveau 1.',
    feat_track_title: 'Suivi personnalisé',
    feat_track_desc: 'Suivez votre progression leçon par leçon : XP, séries et objectifs quotidiens pour rester régulier.',

    /* === HOME : TESTIMONIALS === */
    testim_title: 'Ce que nos clients disent',
    testim_sub: "Plus de 30 étudiants formés, et ce n'est qu'un début",
    testim_1_name: 'Sarah K.',
    testim_1_role: 'Étudiante · Paris',
    testim_1_text: "J'avais peur de parler anglais en public. Après 2 mois sur Academy, j'ai présenté mon projet en anglais devant ma classe. La méthode 4 étapes change tout.",
    testim_2_name: 'Patrick M.',
    testim_2_role: 'Entrepreneur · Londres',
    testim_2_text: "La progression pas à pas, du Niveau 1 jusqu'au bout, m'a vraiment mis en confiance. La progression est claire, motivante, et je me sens enfin à l'aise lors de mes réunions internationales.",
    testim_3_name: 'Aïcha B.',
    testim_3_role: 'Cliente · Montréal',
    testim_3_text: "Je travaille mon anglais 15 min par jour pendant la pause-café. L'app me notifie, garde mon streak, et j'ai déjà mon premier certificat. Bravo !",

    /* === HOME : FAQ === */
    faq_title: 'Questions fréquentes',
    faq_sub: 'Tout ce que vous devez savoir avant de commencer',
    faq_more: 'Voir plus',
    faq_more_n: 'de plus',
    faq_less: 'Voir moins',
    faq_q1: "Comment fonctionne le petit test ?",
    faq_a1: "10 questions rapides pour vous échauffer. À la fin, vous démarrez au Niveau 1 pour suivre tous les modules dans l'ordre et bâtir des bases solides — vous avancerez vite si certaines notions vous sont déjà familières.",
    faq_q2: "Vais-je recevoir un certificat ?",
    faq_a2: "Oui. Un certificat officiel JoSmartTech, signé par le fondateur, est délivré à la fin de chaque formation complète. Il contient un QR code de vérification publique et un numéro de série unique.",
    faq_q3: "Combien de temps faut-il pour terminer le parcours d'anglais ?",
    faq_a3: "Cela dépend de votre rythme. Avec 15-20 min par jour, comptez environ 3 à 4 mois pour aller du Débutant au Fluent. Notre estimateur vous donne une projection personnalisée selon votre temps disponible.",
    faq_q4: "Quelle méthode pédagogique utilisez-vous ?",
    faq_a4: "Chaque leçon suit 5 étapes structurées : Cours (théorie & grammaire expliquée en français avec exemples audio), Lecture (vocabulaire), Exercices (pratique guidée), Mini-chat (mise en situation), Audio Repeat (écoute & répétition à voix haute). C'est cette répétition active qui ancre durablement les acquis.",
    faq_q5: "Puis-je utiliser l'application hors-ligne ?",
    faq_a5: "Oui, JoSmartTech Academy est une PWA (Progressive Web App). Une fois consultées, vos leçons sont mises en cache et accessibles sans connexion internet.",
    faq_q6: "Y a-t-il des rappels quotidiens ?",
    faq_a6: "Vous pouvez activer des notifications push à l'heure de votre choix pour maintenir votre streak. Les rappels sont opt-in et désactivables à tout moment depuis votre tableau de bord.",
    faq_q7: "Le contenu est-il adapté aux débutants complets ?",
    faq_a7: "Absolument. Le niveau Débutant part de zéro : alphabet, sons de base, premiers mots. Vous progressez ensuite à votre rythme, sans être lâché en eaux profondes.",
    faq_q8: "Puis-je suivre les cours sur mobile ?",
    faq_a8: "Oui, l'application est entièrement responsive et optimisée pour mobile, tablette et ordinateur. Vous pouvez même l'installer comme une app native sur votre téléphone.",
    faq_q9: "Comment fonctionne le mode chat du coach ?",
    faq_a9: "À l'étape 3 de chaque leçon, vous interagissez avec votre coach dans des situations réelles (au restaurant, entretien d'embauche, conversation amicale...). Le coach corrige vos réponses et vous donne des alternatives plus naturelles.",
    faq_q10: "Est-ce que je peux revoir mes leçons terminées ?",
    faq_a10: "Oui, toutes vos leçons restent accessibles à vie depuis l'onglet Révision. Vous pouvez aussi mettre vos leçons préférées en favoris pour les retrouver rapidement.",

    /* === HOME : CTA === */
    cta_title: 'Prêt à commencer votre parcours ?',
    cta_sub: "L'inscription est gratuite. Le premier niveau d'anglais aussi. Vous décidez ensuite si vous voulez aller plus loin.",
    cta_btn: 'Commencer maintenant',

    /* === FOOTER === */
    foot_tagline: "Apprenez l'anglais et nos formations professionnelles avec une méthode interactive et accessible.",
    foot_navigation: 'Navigation',
    foot_levels: 'Niveaux',
    foot_contact: 'Contact',
    foot_follow: 'Suivez-nous',
    foot_terms: "Conditions d'utilisation",
    foot_rights: 'Tous droits réservés',
    foot_brand_of: 'Une marque de',
    foot_no_socials: "",

    /* === FORMATION INTRO === */
    fi_eyebrow: 'Mode interactif · 6 niveaux · 🇬🇧',
    fi_title: 'Apprendre l\'anglais',
    fi_subtitle: "Du Débutant au Fluent : 6 niveaux complets (A1 → C1). Lecture, exercices, mini-chat et écoute audio à voix haute. Choisissez votre sens d'apprentissage ci-dessous.",
    fi_direction: "Sens d'apprentissage",
    fi_dir_fr_en: "Apprendre l'anglais (FR → EN)",
    fi_dir_en_fr: 'Learn French (EN → FR)',
    fi_choose: 'Comment veux-tu commencer ?',
    fi_test_badge: 'Recommandé',
    fi_test_title: 'Faire un petit test',
    fi_test_desc: "10 questions rapides, puis tu démarres au Niveau 1.",
    fi_test_cta: 'Lancer le test',
    fi_start_badge: 'Pour les vrais débutants',
    fi_start_title: 'Commencer du début (Module 1)',
    fi_start_desc: "Idéal si tu n'as jamais étudié l'anglais.",
    fi_start_cta: 'Démarrer',
    fi_levels_title: 'Les 6 niveaux qui composent le parcours',
    fi_levels_hint: 'clique pour explorer',
    fi_premium: 'Premium',

    /* === ABOUT PAGE === */
    about_title: 'À propos',
    about_sub: "L'histoire derrière JoSmartTech Academy",
    about_mission: 'Notre mission',
    about_mission_text: "Rendre l'apprentissage de l'anglais et des compétences professionnelles accessible à tous, partout dans le monde, sans barrière financière ni technique.",
    about_method: 'Notre méthode',
    about_method_intro: "Chaque leçon suit une structure simple et puissante en 5 étapes :",
    about_method_step0: "📚 Cours — Vous étudiez la théorie et la grammaire, expliquées en français avec des exemples audio.",
    about_method_step1: '📖 Lecture — Vous découvrez les mots, expressions et règles essentielles.',
    about_method_step2: '✍️ Exercices — Vous pratiquez avec QCM, traduction, complétion et correction.',
    about_method_step3: '💬 Mini-chat — Vous appliquez ce que vous avez appris dans des conversations réalistes.',
    about_method_step4: '🔊 Audio Repeat — Vous écoutez et répétez à voix haute pour ancrer la prononciation.',
    about_vision: 'Notre vision',
    about_vision_text: "Devenir une référence mondiale de l'apprentissage interactif — en commençant par l'anglais, puis en intégrant progressivement nos 28+ formations professionnelles : marketing digital, intelligence artificielle, business, productivité.",
    about_brand: 'Une marque de JoSmartTech',
    about_brand_text: "JoSmartTech Academy est une initiative de JoSmartTech, agence digitale spécialisée dans la création d'applications web, le marketing digital et la formation.",

    /* === FAQ PAGE === */
    faqp_title: 'Questions fréquentes',
    faqp_sub: 'Toutes les réponses à vos questions',

    /* === TERMS PAGE === */
    terms_title: "Conditions d'utilisation",
    terms_sub: 'Cadre légal et règles de la plateforme',

    /* === CONTACT PAGE === */
    contact_title: 'Contact',
    contact_sub: 'Une question ? Une suggestion ? Écrivez-nous.',

    /* === AUTH === */
    auth_login_title: 'Connexion',
    auth_register_title: 'Créer un compte',
    auth_email: 'Email',
    auth_password: 'Mot de passe',
    auth_name: 'Nom complet',
    auth_login_btn: 'Se connecter',
    auth_register_btn: "S'inscrire",
    auth_to_register: "Pas encore de compte ? S'inscrire",
    auth_to_login: 'Déjà inscrit ? Se connecter',

    /* === DASHBOARD === */
    dash_eyebrow: 'Tableau de bord',
    dash_hi: 'Salut',
    dash_streak: 'Streak',
    dash_lives: 'Vies',
    dash_badges: 'Badges',
    dash_global_progress: 'Progression du programme complet',
    dash_lessons_done: 'leçons terminées',
    dash_start_now: 'Commencer maintenant',
    dash_resume: 'Reprendre',
    dash_step: 'Étape',
    dash_start_first: 'Commencer la 1ʳᵉ leçon',
    dash_quick_play: 'Session rapide',
    dash_quick_desc: '5 min de pratique',
    dash_review: 'Révision',
    dash_review_desc: 'Revois tes leçons',
    dash_scenarios: 'Scénarios',
    dash_scenarios_desc: 'Situations réelles',
    dash_listening: 'Écoute',
    dash_listening_desc: 'Podcasts courts',
    dash_certificates: 'Certificats',
    dash_certificates_desc: 'Tes diplômes',
    dash_daily_missions: 'Missions du jour',
    dash_claim: 'Réclamer',
    dash_claimed: 'Réclamé',
    dash_loading: 'Chargement...',

    /* === CATALOG === */
    cat_title: 'Choisis ta leçon',
    cat_module: 'Module',
    cat_lesson: 'Leçon',
    cat_locked: 'Verrouillé',
    cat_done: 'Terminé',
    cat_start: 'Commencer',
    cat_continue: 'Continuer',

    /* === LESSON === */
    lesson_direction: 'Sens',
    lesson_mirror_missing: '⚠️ Version FR en cours de génération…',
    lesson_step1: 'Étape 1 · Lecture',
    lesson_step2: 'Étape 2 · Exercices',
    lesson_step3: 'Étape 3 · Mini-chat',
    lesson_step4: 'Étape 4 · Audio',
    lesson_continue: 'Continuer',
    lesson_submit: 'Valider',
    lesson_next: 'Suivant',
    lesson_correct: 'Correct !',
    lesson_wrong: 'Essaye encore',
    lesson_finished: 'Leçon terminée !',

    /* === PROFILE === */
    profile_title: 'Mon profil',
    profile_stats: 'Statistiques',
    profile_account: 'Compte',
    profile_name: 'Nom',
    profile_logout: 'Déconnexion',
    profile_my_progress: 'Mes progrès',
    profile_steps_done: 'étape(s) complétée(s)',
    profile_xp: 'XP',
    profile_streak: 'Streak',
    profile_lives: 'Vies',

    /* === LESSON extended === */
    lesson_exit: 'Sortir',
    lesson_mode_normal: '🔍 Mode normal',
    lesson_mode_immersion: '🎯 Mode immersion',
    lesson_learn_keys: 'Apprenez les mots clés',
    lesson_ex_fill: 'Complétez la phrase',
    lesson_ex_translate: 'Traduisez',
    lesson_ex_qcm: 'Choisissez la bonne réponse',
    lesson_ex_correct_type: 'Corrigez la phrase',
    lesson_your_answer: 'Votre réponse...',
    lesson_answer_label: 'Réponse :',
    lesson_question_label: 'Question',
    lesson_reveal: 'Voir la réponse',
    lesson_no_chat: 'Pas de mini-chat dans cette leçon.',
    lesson_listen_attentively: '🔊 Écoutez attentivement...',
    lesson_your_turn: '🎤 À votre tour de répéter !',
    lesson_listen: 'Écouter',
    lesson_replay: 'Rejouer',
    lesson_skip: 'Passer',
    lesson_speed: 'Vitesse',
    lesson_speed_slow: 'Lent',
    lesson_speed_normal: 'Normal',
    lesson_speed_fast: 'Rapide',
    lesson_continuous: 'Lecture continue',
    lesson_step1_label: 'Étape 1 · Lecture',
    lesson_step2_label: 'Étape 2 · Exercices',
    lesson_step3_label: 'Étape 3 · Mini-chat',
    lesson_step4_label: 'Étape 4 · Écouter & Répéter',

    /* === FAVORITES === */
    fav_title: 'Mes favoris',
    fav_sub: 'Tes leçons sauvegardées pour y revenir rapidement.',
    fav_empty: "Aucun favori. Clique sur l'étoile d'une leçon pour l'ajouter ici.",

    /* === AUTH extended === */
    auth_your_name: 'Votre nom',
    auth_create_mine: 'Créer mon compte',
    auth_login_tab: 'Connexion',
    auth_register_tab: 'Créer un compte',
    auth_login_success: 'Connexion réussie',
    auth_register_success: 'Compte créé !',
    auth_welcome_admin: 'Bienvenue admin — accès complet au site',

    /* === ADMIN === */
    admin_access_title: 'Accès Admin Academy',
    admin_access_hint: "Connecte-toi avec ton compte admin via le formulaire de connexion. Ou saisis le mot de passe admin séparé ci-dessous (legacy) :",
    admin_pwd_placeholder: 'Mot de passe admin (legacy)',
    admin_login_btn: 'Se connecter',
    admin_mode_active: 'Mode admin actif',
    admin_mode_hint: '— Tu peux modifier, ajouter et consulter les statistiques',
    admin_preview_site: 'Voir le site',
    admin_panel_title: 'Panneau Admin',
    admin_logout: 'Déconnexion admin',
    admin_stat_users: 'Utilisateurs',
    admin_stat_premium: 'Premium',
    admin_stat_modules: 'Modules',
    admin_stat_lessons: 'Leçons',
    admin_stat_steps: 'Étapes faites',
    admin_tab_generate: 'Générer une leçon',
    admin_tab_lessons: 'Leçons publiées',
    admin_tab_users: 'Utilisateurs',
    admin_tab_pricing: '💰 Tarifs / Premium',
    admin_tab_payments: '📥 Paiements',
    admin_tab_revenue: '📊 Revenus',
    admin_tab_paysettings: '💳 Coordonnées',
    admin_tab_settings: 'Réglages',
    admin_gen_title_ph: 'Titre (ex: Les salutations)',
    admin_gen_btn: "Générer avec l'IA",
    admin_gen_preview: 'Aperçu',
    admin_gen_order: 'Ordre',
    admin_gen_publish: 'Publier',
    admin_gen_cancel: 'Annuler',
    admin_gen_success: "Leçon générée avec l'IA",
    admin_gen_published: 'Leçon publiée !',
    admin_del_confirm: 'Supprimer cette leçon ?',
    admin_del_ok: 'Supprimée',
    admin_no_lessons: 'Aucune leçon.',
    admin_no_users: 'Aucun utilisateur inscrit.',
    admin_col_name: 'Nom',
    admin_col_email: 'Email',
    admin_col_xp: 'XP',
    admin_col_premium: 'Premium',
    admin_settings_free: 'Accès gratuit',
    admin_settings_step1: 'Étape 1 (Lecture)',
    admin_settings_step2: 'Étape 2 (Exercices)',
    admin_settings_step3: 'Étape 3 (Mini-chat)',
    admin_settings_step4: 'Étape 4 (Audio)',
    admin_settings_free_mod: 'Leçons gratuites/module',
    admin_settings_free_day: 'Leçons gratuites/jour',
    admin_settings_save: 'Enregistrer',
    admin_settings_saved: 'Réglages enregistrés',

    /* === LEADERBOARD === */
    lb_title: 'Classement',
    lb_week: 'Semaine',
    lb_all: 'Général',
    lb_me: 'vous',
    lb_empty: 'Aucun apprenant cette semaine — sois le premier !',
    lb_your_rank: 'Votre position',

    /* === STREAK CALENDAR === */
    sc_title: 'Mon rythme (28 jours)',
    sc_less: 'Moins',
    sc_more: 'Plus',
    sc_active_days: 'Jours actifs',

    /* === DAILY CHALLENGE === */
    dc_title: 'Défi du jour',
    dc_done: 'Réussi',
    dc_placeholder: 'Ta réponse...',
    dc_submit: 'Valider',
    dc_hint: 'Indice',
    dc_expected: 'Réponse attendue :',
    dc_come_back: 'Reviens demain pour un nouveau défi !',

    /* === GUIDE — Comment utiliser l'app === */
    nav_guide: 'Guide',
    guide_eyebrow: 'Bien démarrer',
    guide_title: 'Comment utiliser JoSmartTech Academy',
    guide_sub: 'Un tour rapide en 6 étapes pour tirer le meilleur de l\'app.',
    guide_prev: 'Précédent',
    guide_next: 'Suivant',
    guide_finish: 'C\'est parti !',
    guide_skip: 'Ne plus afficher',

    step_method_title: '1. La méthode 5 étapes',
    step_method_desc: 'Chaque leçon suit le même rythme :\n📚 Cours — tu étudies la théorie et la grammaire (avec exemples audio)\n📖 Lecture — tu découvres les mots-clés\n✍️ Exercices — tu pratiques (QCM, traduction, complétion)\n💬 Mini-chat — tu appliques dans une vraie conversation\n🔊 Audio Repeat — tu écoutes et répètes à voix haute',

    step_dailychallenge_title: '2. Le défi du jour',
    step_dailychallenge_desc: 'Une seule question boostée chaque jour (+40 XP). Partagée par tous les apprenants. Un indice est disponible si tu bloques. Reviens chaque matin !',

    step_gamification_title: '3. XP, vies, badges & classement',
    step_gamification_desc: 'Chaque leçon terminée te rapporte automatiquement des points (XP) — au moins +10 par leçon. Tu gagnes aussi des XP à chaque étape validée, tu débloques des badges (premier mot, 7 jours d\'affilée, score parfait…) et tu montes dans le classement hebdomadaire.',

    step_streak_title: '4. Ta série quotidienne (streak)',
    step_streak_desc: '15 min par jour suffisent. Active les rappels push pour maintenir ta série. Le calendrier de rythme te montre tes 28 derniers jours d\'activité — plus c\'est vert, plus tu progresses.',

    step_certificates_title: '5. Certificats officiels',
    step_certificates_desc: 'Le certificat officiel JoSmartTech se débloque à la toute fin du parcours, quand tu as terminé les 6 niveaux à 100 %. Il est numérique, signé, avec QR code de vérification et numéro unique — à partager sur LinkedIn ou à imprimer.',

    step_goal_title: '6. Choisis ton sens d\'apprentissage',
    step_goal_desc: 'Le parcours est pensé pour les francophones qui apprennent l\'anglais. Tu commences avec des explications en français, puis l\'anglais prend de plus en plus de place à mesure que tu montes de niveau — jusqu\'à un cours entièrement en anglais. Avance niveau par niveau, sans sauter les bases.',
  },

  en: {
    nav_home: 'Home',
    nav_about: 'About',
    nav_formations: 'Our Courses',
    nav_login: 'Sign in',
    nav_dashboard: 'Dashboard',
    nav_modules: 'Modules',
    nav_admin: 'Admin',
    nav_logout: 'Sign out',
    back: 'Back',

    hero_badge: 'Learn at your pace, gain confidence',
    hero_subtitle: 'Learn English and our professional courses with an interactive method: listen, repeat, practice, validate.',
    hero_cta_start: 'Start for free',
    hero_cta_try: 'Try it now',
    hero_cta_discover: 'Discover our courses',

    formations_title: 'Our courses',
    formation_english_tag: 'Interactive mode · 6 levels · 🇬🇧',
    formation_english_title: 'Learn English',
    formation_english_desc: 'From Beginner to Fluent — 5-step method (Lesson, Reading, Exercises, Mini-chat, Audio Repeat) to learn English step by step.',
    formation_english_cta: 'Discover',
    formation_pro_tag: 'Academic mode',
    formation_pro_title: 'Pro Courses',
    formation_pro_desc: 'Fast-track course: build websites & apps with AI — in person or online.',
    formation_pro_cta: 'Discover',
    formations_more_banner: '💡 More courses coming soon: Digital Marketing, Artificial Intelligence, Business, Productivity…',
    formations_catalog_badge: 'Full catalog',
    formations_intro: 'Choose your learning field. Every course follows our interactive method: listen, repeat, practice, validate.',

    why_title: 'Why choose us?',
    why_sub: 'A method designed for confidence and real-world practice',
    why_method: 'Interactive method',
    why_method_desc: '4 steps per lesson: Read, Practice, Chat, Listen & Repeat.',
    why_audio: 'Unlimited audio',
    why_audio_desc: 'Listen and repeat each sentence at your own pace.',
    why_gami: 'Gamification',
    why_gami_desc: 'XP, streaks, lives, and badges to keep you motivated.',
    why_certs: 'Certificates',
    why_certs_desc: 'Officially validate your progress at the end of each course.',

    founder_eyebrow: 'A word from the founder',
    founder_role: 'Founder · CEO',
    founder_quote: '"Knowledge has',
    founder_quote_em: 'no borders',
    founder_p1_a: 'To all the ',
    founder_p1_youth: 'young minds',
    founder_p1_b: ', to all the ',
    founder_p1_entrepreneurs: 'entrepreneurs',
    founder_p1_c: ', to everyone who dares to dream bigger: this project is for you.',
    founder_p2_a: 'JoSmartTech was born from one simple conviction — ',
    founder_p2_strong: 'technology and knowledge must belong to everyone',
    founder_p2_b: ', everywhere in the world. Whatever your continent, language or starting point: you deserve the same tools, the same learning quality, the same opportunities.',
    founder_p3_a: "Today, the internet has erased distance. An idea born in a small bedroom can change the world. Talent can rise from anywhere. Our role here is simple: to give you ",
    founder_p3_strong: 'the skills, the confidence, and the consistency',
    founder_p3_b: ' to turn that possibility into reality.',
    founder_p4_a: "Don't wait for the perfect moment. Learn today. Practice tomorrow. Build the day after. And remember: ",
    founder_p4_strong: 'every great journey begins with a single lesson',
    founder_signature_role: 'Founder of JoSmartTech',

    features_title: 'Essential features',
    features_sub: 'Everything you expect from a modern platform — and more',
    feat_method_title: 'Interactive method',
    feat_method_desc: '5 steps per lesson: Lesson, Read, Practice, Chat, Listen & Repeat.',
    feat_audio_title: 'Unlimited audio',
    feat_audio_desc: 'Listen and repeat each sentence at your own pace — as many times as needed.',
    feat_gami_title: 'Gamification',
    feat_gami_desc: 'XP, streaks, lives, and badges to keep you motivated every day.',
    feat_certs_title: 'Official certificates',
    feat_certs_desc: 'Receive a JoSmartTech certificate at the end of each complete course.',
    feat_ai_title: 'Quick warm-up quiz',
    feat_ai_desc: 'A 10-question warm-up, then you start smoothly at Level 1.',
    feat_track_title: 'Personalized tracking',
    feat_track_desc: 'Follow your progress lesson by lesson: XP, streaks and daily goals to stay consistent.',

    testim_title: 'What our students say',
    testim_sub: 'Over 30 students trained — and this is just the beginning',
    testim_1_name: 'Sarah K.',
    testim_1_role: 'Student · Paris',
    testim_1_text: "I used to be afraid of speaking English in public. After 2 months on Academy, I presented my project in English in front of my class. The 4-step method changes everything.",
    testim_2_name: 'Patrick M.',
    testim_2_role: 'Entrepreneur · London',
    testim_2_text: "Progressing step by step, from Level 1 all the way through, really built my confidence. Progression is clear, motivating, and I finally feel comfortable in international meetings.",
    testim_3_name: 'Aïcha B.',
    testim_3_role: 'Customer · Montreal',
    testim_3_text: "I work on my English 15 min a day during my coffee break. The app reminds me, keeps my streak, and I already have my first certificate. Brilliant!",

    faq_title: 'Frequently asked questions',
    faq_sub: 'Everything you need to know before you start',
    faq_more: 'See more',
    faq_more_n: 'more',
    faq_less: 'See less',
    faq_q1: 'How does the quick quiz work?',
    faq_a1: 'Ten quick questions to warm you up. At the end, you start at Level 1 to follow every module in order and build solid foundations — you will move fast if some notions are already familiar.',
    faq_q2: 'Will I receive a certificate?',
    faq_a2: 'Yes. An official JoSmartTech certificate, signed by the founder, is delivered at the end of each complete course. It includes a public verification QR code and a unique serial number.',
    faq_q3: 'How long does the English path take?',
    faq_a3: 'It depends on your pace. With 15-20 minutes a day, expect about 3 to 4 months from Beginner to Fluent. Our estimator gives you a personalized projection based on your available time.',
    faq_q4: 'What teaching method do you use?',
    faq_a4: 'Each lesson follows 5 structured steps: Lesson (theory & grammar explained with audio examples), Reading (vocabulary), Exercises (guided practice), Mini-chat (real situations), Audio Repeat (listen & repeat aloud). This active repetition is what anchors learning.',
    faq_q5: 'Can I use the app offline?',
    faq_a5: 'Yes, JoSmartTech Academy is a PWA (Progressive Web App). Once viewed, your lessons are cached and accessible without internet.',
    faq_q6: 'Are there daily reminders?',
    faq_a6: 'You can enable push notifications at the time you choose to maintain your streak. Reminders are opt-in and can be disabled at any time from your dashboard.',
    faq_q7: 'Is the content suitable for total beginners?',
    faq_a7: 'Absolutely. The Beginner level starts from zero: alphabet, basic sounds, first words. You then progress at your pace, never thrown into deep water.',
    faq_q8: 'Can I follow the courses on mobile?',
    faq_a8: 'Yes, the application is fully responsive and optimized for mobile, tablet, and desktop. You can even install it as a native app on your phone.',
    faq_q9: 'How does the coach chat mode work?',
    faq_a9: 'In step 3 of each lesson, you interact with your coach in real-life scenarios (at the restaurant, job interview, friendly conversation...). The coach corrects your answers and offers more natural alternatives.',
    faq_q10: 'Can I review my completed lessons?',
    faq_a10: 'Yes, all your lessons remain accessible for life from the Review tab. You can also bookmark your favorite lessons to find them quickly.',

    cta_title: 'Ready to start your journey?',
    cta_sub: "Sign-up is free. So is the first level of English. You'll decide later if you want to go further.",
    cta_btn: 'Start now',

    foot_tagline: 'Learn English and our professional courses with an interactive and accessible method.',
    foot_navigation: 'Navigation',
    foot_levels: 'Levels',
    foot_contact: 'Contact',
    foot_follow: 'Follow us',
    foot_terms: 'Terms of use',
    foot_rights: 'All rights reserved',
    foot_brand_of: 'A brand of',
    foot_no_socials: '',

    fi_eyebrow: 'Interactive mode · 6 levels · 🇬🇧',
    fi_title: 'Learn English',
    fi_subtitle: 'From Beginner to Fluent: 6 complete levels (A1 → C1). Reading, exercises, mini-chat and out-loud audio practice. Pick your learning direction below.',
    fi_direction: 'Learning direction',
    fi_dir_fr_en: "Apprendre l'anglais (FR → EN)",
    fi_dir_en_fr: 'Learn French (EN → FR)',
    fi_choose: 'How would you like to start?',
    fi_test_badge: 'Recommended',
    fi_test_title: 'Take a quick quiz',
    fi_test_desc: 'Ten quick questions, then you start at Level 1.',
    fi_test_cta: 'Take the test',
    fi_start_badge: 'For real beginners',
    fi_start_title: 'Start from the beginning (Module 1)',
    fi_start_desc: "Ideal if you've never studied English before.",
    fi_start_cta: 'Get started',
    fi_levels_title: 'The 6 levels in this path',
    fi_levels_hint: 'click to explore',
    fi_premium: 'Premium',

    about_title: 'About',
    about_sub: 'The story behind JoSmartTech Academy',
    about_mission: 'Our mission',
    about_mission_text: 'To make learning English and professional skills accessible to everyone, everywhere in the world, with no financial or technical barrier.',
    about_method: 'Our method',
    about_method_intro: 'Each lesson follows a simple and powerful 5-step structure:',
    about_method_step0: '📚 Lesson — You study the theory and grammar, explained in French with audio examples.',
    about_method_step1: '📖 Reading — You discover the essential words, phrases, and rules.',
    about_method_step2: '✍️ Exercises — You practice with MCQ, translation, completion, and correction.',
    about_method_step3: '💬 Mini-chat — You apply what you learned in realistic conversations.',
    about_method_step4: '🔊 Audio Repeat — You listen and repeat aloud to anchor pronunciation.',
    about_vision: 'Our vision',
    about_vision_text: 'To become a worldwide reference for interactive learning — starting with English, then progressively integrating our 28+ professional courses: digital marketing, AI, business, productivity.',
    about_brand: 'A brand of JoSmartTech',
    about_brand_text: 'JoSmartTech Academy is an initiative of JoSmartTech, a digital agency specialized in web app creation, digital marketing, and training.',

    faqp_title: 'Frequently asked questions',
    faqp_sub: 'All the answers to your questions',

    terms_title: 'Terms of use',
    terms_sub: 'Legal framework and platform rules',

    contact_title: 'Contact',
    contact_sub: 'A question? A suggestion? Write to us.',

    auth_login_title: 'Sign in',
    auth_register_title: 'Create an account',
    auth_email: 'Email',
    auth_password: 'Password',
    auth_name: 'Full name',
    auth_login_btn: 'Sign in',
    auth_register_btn: 'Sign up',
    auth_to_register: "Don't have an account yet? Sign up",
    auth_to_login: 'Already registered? Sign in',

    dash_eyebrow: 'Dashboard',
    dash_hi: 'Hi',
    dash_streak: 'Streak',
    dash_lives: 'Lives',
    dash_badges: 'Badges',
    dash_global_progress: 'Overall program progress',
    dash_lessons_done: 'lessons done',
    dash_start_now: 'Start now',
    dash_resume: 'Resume',
    dash_step: 'Step',
    dash_start_first: 'Start the first lesson',
    dash_quick_play: 'Quick session',
    dash_quick_desc: '5 min of practice',
    dash_review: 'Review',
    dash_review_desc: 'Review your lessons',
    dash_scenarios: 'Scenarios',
    dash_scenarios_desc: 'Real-life situations',
    dash_listening: 'Listening',
    dash_listening_desc: 'Short podcasts',
    dash_certificates: 'Certificates',
    dash_certificates_desc: 'Your diplomas',
    dash_daily_missions: 'Daily missions',
    dash_claim: 'Claim',
    dash_claimed: 'Claimed',
    dash_loading: 'Loading...',

    cat_title: 'Pick your lesson',
    cat_module: 'Module',
    cat_lesson: 'Lesson',
    cat_locked: 'Locked',
    cat_done: 'Done',
    cat_start: 'Start',
    cat_continue: 'Continue',

    lesson_direction: 'Direction',
    lesson_mirror_missing: '⚠️ FR version being generated…',
    lesson_step1: 'Step 1 · Reading',
    lesson_step2: 'Step 2 · Exercises',
    lesson_step3: 'Step 3 · Mini-chat',
    lesson_step4: 'Step 4 · Audio',
    lesson_continue: 'Continue',
    lesson_submit: 'Submit',
    lesson_next: 'Next',
    lesson_correct: 'Correct!',
    lesson_wrong: 'Try again',
    lesson_finished: 'Lesson complete!',

    profile_title: 'My profile',
    profile_stats: 'Statistics',
    profile_account: 'Account',
    profile_name: 'Name',
    profile_logout: 'Sign out',
    profile_my_progress: 'My progress',
    profile_steps_done: 'step(s) completed',
    profile_xp: 'XP',
    profile_streak: 'Streak',
    profile_lives: 'Lives',

    lesson_exit: 'Exit',
    lesson_mode_normal: '🔍 Normal mode',
    lesson_mode_immersion: '🎯 Immersion mode',
    lesson_learn_keys: 'Learn the key words',
    lesson_ex_fill: 'Fill in the sentence',
    lesson_ex_translate: 'Translate',
    lesson_ex_qcm: 'Pick the right answer',
    lesson_ex_correct_type: 'Correct the sentence',
    lesson_your_answer: 'Your answer...',
    lesson_answer_label: 'Answer:',
    lesson_question_label: 'Question',
    lesson_reveal: 'Show answer',
    lesson_no_chat: 'No mini-chat in this lesson.',
    lesson_listen_attentively: '🔊 Listen carefully...',
    lesson_your_turn: '🎤 Your turn to repeat!',
    lesson_listen: 'Play',
    lesson_replay: 'Replay',
    lesson_skip: 'Skip',
    lesson_speed: 'Speed',
    lesson_speed_slow: 'Slow',
    lesson_speed_normal: 'Normal',
    lesson_speed_fast: 'Fast',
    lesson_continuous: 'Continuous play',
    lesson_step1_label: 'Step 1 · Reading',
    lesson_step2_label: 'Step 2 · Exercises',
    lesson_step3_label: 'Step 3 · Mini-chat',
    lesson_step4_label: 'Step 4 · Listen & Repeat',

    fav_title: 'My favorites',
    fav_sub: 'Your bookmarked lessons to come back quickly.',
    fav_empty: "No favorite yet. Click a lesson's star to add it here.",

    auth_your_name: 'Your name',
    auth_create_mine: 'Create my account',
    auth_login_tab: 'Sign in',
    auth_register_tab: 'Sign up',
    auth_login_success: 'Signed in',
    auth_register_success: 'Account created!',
    auth_welcome_admin: 'Welcome admin — full site access',

    admin_access_title: 'Academy Admin Access',
    admin_access_hint: 'Sign in with your admin account via the login form. Or enter the separate admin password below (legacy):',
    admin_pwd_placeholder: 'Admin password (legacy)',
    admin_login_btn: 'Sign in',
    admin_mode_active: 'Admin mode active',
    admin_mode_hint: '— You can edit, add and view statistics',
    admin_preview_site: 'View site',
    admin_panel_title: 'Admin panel',
    admin_logout: 'Admin sign out',
    admin_stat_users: 'Users',
    admin_stat_premium: 'Premium',
    admin_stat_modules: 'Modules',
    admin_stat_lessons: 'Lessons',
    admin_stat_steps: 'Steps done',
    admin_tab_generate: 'Generate a lesson',
    admin_tab_lessons: 'Published lessons',
    admin_tab_users: 'Users',
    admin_tab_pricing: '💰 Pricing / Premium',
    admin_tab_payments: '📥 Payments',
    admin_tab_revenue: '📊 Revenue',
    admin_tab_paysettings: '💳 Bank details',
    admin_tab_settings: 'Settings',
    admin_gen_title_ph: 'Title (e.g. Greetings)',
    admin_gen_btn: 'Generate with AI',
    admin_gen_preview: 'Preview',
    admin_gen_order: 'Order',
    admin_gen_publish: 'Publish',
    admin_gen_cancel: 'Cancel',
    admin_gen_success: 'Lesson generated with AI',
    admin_gen_published: 'Lesson published!',
    admin_del_confirm: 'Delete this lesson?',
    admin_del_ok: 'Deleted',
    admin_no_lessons: 'No lesson.',
    admin_no_users: 'No user signed up yet.',
    admin_col_name: 'Name',
    admin_col_email: 'Email',
    admin_col_xp: 'XP',
    admin_col_premium: 'Premium',
    admin_settings_free: 'Free access',
    admin_settings_step1: 'Step 1 (Reading)',
    admin_settings_step2: 'Step 2 (Exercises)',
    admin_settings_step3: 'Step 3 (Mini-chat)',
    admin_settings_step4: 'Step 4 (Audio)',
    admin_settings_free_mod: 'Free lessons/module',
    admin_settings_free_day: 'Free lessons/day',
    admin_settings_save: 'Save',
    admin_settings_saved: 'Settings saved',

    lb_title: 'Leaderboard',
    lb_week: 'Week',
    lb_all: 'All-time',
    lb_me: 'you',
    lb_empty: 'No learner this week — be the first!',
    lb_your_rank: 'Your rank',

    sc_title: 'My pace (28 days)',
    sc_less: 'Less',
    sc_more: 'More',
    sc_active_days: 'Active days',

    dc_title: 'Daily challenge',
    dc_done: 'Completed',
    dc_placeholder: 'Your answer...',
    dc_submit: 'Submit',
    dc_hint: 'Hint',
    dc_expected: 'Expected:',
    dc_come_back: 'Come back tomorrow for a new challenge!',

    /* === GUIDE === */
    nav_guide: 'Guide',
    guide_eyebrow: 'Getting started',
    guide_title: 'How to use JoSmartTech Academy',
    guide_sub: 'A quick 6-step tour to get the most out of the app.',
    guide_prev: 'Back',
    guide_next: 'Next',
    guide_finish: "Let's go!",
    guide_skip: "Don't show again",

    step_method_title: '1. The 5-step method',
    step_method_desc: 'Every lesson follows the same rhythm:\n📚 Lesson — study the theory and grammar (with audio examples)\n📖 Reading — discover the key words\n✍️ Exercises — practice (MCQ, translation, completion)\n💬 Mini-chat — apply it in a real conversation\n🔊 Audio Repeat — listen and repeat aloud',

    step_dailychallenge_title: '2. The daily challenge',
    step_dailychallenge_desc: 'One boosted question every day (+40 XP). Shared by all learners. A hint is available if you\'re stuck. Come back every morning!',

    step_gamification_title: '3. XP, lives, badges & leaderboard',
    step_gamification_desc: 'Each completed step rewards you with XP. 5 lives per day. Unlock badges (first word, 7-day streak, perfect score…) and climb the weekly leaderboard to beat your friends.',

    step_streak_title: '4. Your daily streak',
    step_streak_desc: '15 minutes a day is enough. Enable push reminders to keep your streak alive. The pace calendar shows your last 28 active days — the greener, the better.',

    step_certificates_title: '5. Official certificates',
    step_certificates_desc: 'At 100% of a full course, you get a signed JoSmartTech digital certificate, with a public QR verification code and a unique serial number. Share it on LinkedIn or print it.',

    step_goal_title: '6. Pick your learning direction',
    step_goal_desc: 'The course is designed for French speakers learning English. You start with explanations in French, then English gradually takes over as you level up — until the course is fully in English. Progress level by level without skipping the basics.',
  },

  // Lingala — activé (traductions de base, fallback FR pour le reste)
  ln: {
    nav_home: 'Ndako',
    nav_about: 'Mpo na biso',
    nav_formations: 'Mateya na biso',
    nav_login: 'Kota',
    nav_dashboard: 'Tableau',
    nav_modules: 'Mateya',
    nav_admin: 'Admin',
    nav_logout: 'Kobima',
    nav_guide: 'Litambwisi',
    back: 'Kozonga',

    hero_badge: 'Yekola na mbala na yo, zwa elikya',
    hero_subtitle: "Yekola Angele mpe mateya na biso ya misala na lolenge ya sika : koyoka, kozongela, komeka, kondimisa.",
    hero_cta_start: 'Banda ofele',
    hero_cta_try: 'Meka sikoyo',
    hero_cta_discover: 'Tala mateya',

    cta_title: 'Osili te mpo na kobanda ?',
    cta_sub: "Kokoma nkombo ezali ofele. Niveau ya liboso ya Angele mpe ezali ofele.",
    cta_btn: 'Banda sikawa',

    auth_login_title: 'Kota',
    auth_register_title: 'Sala compte',
    auth_email: 'Email',
    auth_password: 'Mot de passe',
    auth_name: 'Nkombo',
    auth_login_btn: 'Kota',
    auth_register_btn: 'Kokoma nkombo',

    dash_eyebrow: 'Tableau',
    dash_hi: 'Mbote',
    dash_streak: 'Série',
    dash_lives: 'Bomoi',
    dash_badges: 'Badges',
    dash_start_now: 'Banda sikawa',
    dash_resume: 'Zongela',
    dash_loading: 'Ezali kofungwama...',

    lb_title: 'Classement',
    lb_week: 'Poso',
    lb_all: 'Nyonso',
    lb_me: 'yo',

    sc_title: 'Rythme na ngai (mikolo 28)',
    sc_less: 'Moke',
    sc_more: 'Ebele',
    sc_active_days: 'Mikolo ya misala',

    dc_title: 'Défi ya mokolo',
    dc_submit: 'Kondimisa',
    dc_hint: 'Elembo',
    dc_come_back: 'Zonga lobi mpo na défi ya sika !',

    guide_eyebrow: 'Banda malamu',
    guide_title: 'Ndenge ya kosalela JoSmartTech Academy',
    guide_sub: 'Mokuse ya bakuse 6 mpo na kozwa mingi na application.',
    guide_prev: 'Liboso',
    guide_next: 'Oyo elandi',
    guide_finish: 'Tokende !',
    guide_skip: 'Kolakisa lisusu te',
  },
};

/** Returns a translator function for the given language. Falls back to FR. */
export function getT(lang) {
  const dict = (T[lang] && Object.keys(T[lang]).length > 0) ? T[lang] : T.fr;
  const fr = T.fr;
  return (key) => {
    if (dict[key] != null) return dict[key];
    if (fr[key] != null) return fr[key];
    return key;
  };
}
